export enum EnvsEnum {
	'prod' = 'prod',
	'dev' = 'dev',
	'devWinplc' = 'devWinplc',
	'prodWinplc' = 'prodWinplc',
	'preprod' = 'preprod',
	'testprod' = 'testprod',
	'testing' = 'testing'
}

export enum AppIdsEnum {
	'preprod' = '0728ef58-406e-4aa2-8d20-2b41d5810e39',
	'testing' = '0728ef58-406e-4aa2-8d20-2b41d5810e39',
	// 'testing' = '0bdc87d2-0411-445b-a5fe-7b776c4f243e',
	'winplc' = '40ba869d-9792-4181-99c1-a1e8c9717ff6',
}

export enum AvailableLangs {
	'en' = 'en',
	'da' = 'da'
}

export interface EnvironmentInterface {
	name: EnvsEnum;
	baseUrl: string;
	storagePrefix: string;
	production: boolean;
	apiUrl: string;
	mockApi: string;
	defaultLang: AvailableLangs;
	appId: AppIdsEnum;
}
